import React, { memo } from 'react'
import { array } from 'prop-types'
import serverData from '../utils/server-data'
import { Col, HeadingText, Badge } from '@paypalcorp/pp-react'
import SubSections from './sub-sections'

const Sections = memo((props) =>
  props.sections.map(
    ({
      sectionId,
      sectionName,
      hasElmoTreatment,
      badge = {},
      subSections = [],
      isEnabled,
    }) =>
      isEnabled &&
      hasElmoTreatment &&
      (serverData.isMerchantUser ? (
        <div
          className="merchant-section-container"
          key={sectionName}
          id={sectionId}
        >
          <Col>
            <HeadingText
              id={`${sectionId}Header`}
              size="md"
              className="merchant-section-header"
            >
              {sectionName}
            </HeadingText>
            <SubSections subSections={subSections} {...props} />
          </Col>
        </div>
      ) : (
        <div className="section-container" key={sectionName} id={sectionId}>
          <Col lg={12}>
            <HeadingText
              id={`${sectionId}Header`}
              size="xs"
              className="section-header"
            >
              {sectionName}
              {badge.type && (
                <Badge type={badge.type} className="section-badge" theme="v2">
                  {badge.text}
                </Badge>
              )}
            </HeadingText>
            <SubSections subSections={subSections} {...props} />
          </Col>
        </div>
      )),
  ),
)

Sections.propTypes = {
  sections: array,
}

Sections.defaultProps = {
  sections: [],
}

Sections.displayName = 'Sections'

export default Sections
